import Auth from 'store/auth';
import CategoryStore from 'store/categoryStore';
import BudgetStore from './budgetStore';
import UserStore from 'store/user';
import AppStore from 'store/app';
import FamilyStore from 'store/familyStore';

class RootStore {
    constructor() {
        this.app = new AppStore(this);
        this.auth = new Auth(this);
        this.categories = new CategoryStore(this);
        this.budget = new BudgetStore(this);
        this.user = new UserStore(this);
        this.family = new FamilyStore(this);
    }
}

const rootStore = new RootStore();

export default rootStore;


// WEBPACK FOOTER //
// ./src/store/rootStore.js